var map = {
	"./WASD.png": 2761,
	"./ZQSD.png": 1796,
	"./arrows.png": 9850,
	"./art/biome1.png": 5841,
	"./art/biome2.png": 8353,
	"./art/biome3.png": 1252,
	"./art/biome3b.png": 4585,
	"./art/biome4.png": 1332,
	"./art/cartepostalejambes.png": 5958,
	"./art/cartepostaletour.png": 6207,
	"./button_A.png": 1675,
	"./button_B.png": 9880,
	"./button_C.png": 6858,
	"./cross.png": 4377,
	"./en.png": 3147,
	"./en/about.png": 2551,
	"./en/art.png": 7908,
	"./en/credits.png": 766,
	"./en/fountains.png": 7301,
	"./en/instructions.png": 3943,
	"./en/menu.png": 4931,
	"./en/play.png": 9966,
	"./en/tendersound.png": 5694,
	"./en/tobecontinued.png": 4534,
	"./enter.png": 3545,
	"./entree.png": 5320,
	"./fr.png": 8970,
	"./fr/about.png": 4145,
	"./fr/art.png": 9157,
	"./fr/credits.png": 7090,
	"./fr/fountains.png": 7642,
	"./fr/instructions.png": 4641,
	"./fr/menu.png": 4819,
	"./fr/play.png": 2954,
	"./fr/tendersound.png": 7415,
	"./fr/tobecontinued.png": 1926,
	"./logos/billieness.png": 2943,
	"./logos/cnc.png": 9937,
	"./logos/fondation-des-artistes.png": 2535,
	"./logos/latraverse.png": 7667,
	"./logos/outofpluto.png": 2721,
	"./logos/scam.png": 6417,
	"./p.png": 9704,
	"./slash.png": 90,
	"./space.png": 1093,
	"./sphinx.png": 1708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;